export default (status) => {
    const state = Number(status)
    let result
    switch (status) {
        case 0:
            result = '审核中'
            break;
        case 1:
            result = '审核通过'

            break;
        case 2:
            result = '审核不通过'
            break;
        case 3:
            result = '待定'
            break;
        default:
            break;

    }
    return result
}